import tw from 'tailwind-styled-components'

export const Label = tw.label`
flex 
flex-col 
items-center 
justify-center 
w-full 
h-[38px] 
border-[1px] 
border-dashed 
border-blueTheme 
rounded-lg 
cursor-pointer
`

export const MainFile = tw.div`
flex 
flex-row 
items-center 
justify-center 
align-center
pt-5 
pb-6
mt-1
`

export const FileContainer = tw.div`
w-full
px-4 
py-1 
bg-lightGray 
rounded-lg 
flex 
items-center 
gap-[25px]
justify-between
`